
import { CommonModule } from "@angular/common";
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormGroup, FormControl, Validators,FormArray,FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { ApiService } from "src/app/service/api.service";
import { NotificationService } from 'src/app/service/notification.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { PipePipe } from "src/app/service/pipe.pipe";
import { Header1Component } from "src/app/elements/header/header1/header1.component";

@Component({
  selector: 'app-applicant-registration',
  templateUrl: './applicant-registration.component.html',
  styleUrls: ['./applicant-registration.component.css'],
  providers:[PipePipe],
})
export class ApplicantRegistrationComponent implements OnInit {
	@ViewChild(Header1Component) Header1Component!: Header1Component;

	moment=moment;
    hideDOB=true;
	patientdet: any;
	applicant_data: any;
	countrynew: any;
	selectableCountries: [];
	selectedCurrency: any;

	constructor(private fb: FormBuilder,public api:ApiService,private notification : NotificationService) {
	  // Login Form
	 
	  const token=this.api.getToken('applicant', this.api.encrypt('Applicant@123',environment.SECRET_KEY)).subscribe((res)=>{
		console.log("resssss",res);
		
	  });
	  
	  this.ofc_phone = { allCountries: [] }; 
	  this.ofc_phone2 = { allCountries: [] }; 
	}
	lookupVal:any
	date = moment(new Date()).format(environment.DATE_FORMAT_REVERSE);
    dob:any;
	@ViewChild('ofc_phone') ofc_phone: any;
	@ViewChild('ofc_phone2') ofc_phone2: any;
	defaultPhoneCountry=['in'];
	ClientHidden=false;

	ngOnInit(): void {
	
		const token=localStorage.getItem('access-token');
		console.log("token",token);
		

		// this.snackBar.open('Test Snackbar', 'Close', { duration: 3000 });
	if(token){
		this.getSalutation();
		this.getCenter();
		this.getGender();
		this.getMaritalStatus();
		this.getCountry();
		this.getVisitType();
		this.getReferralPerson();
		this.getEducationLevel();
		this.getOccupation();
		this.getEmergencyRelationship();
		this.getClient();		
	}
	
	}

    RegisterForm=new FormGroup({
		id: new FormControl(''),
		title : new FormControl('',[Validators.required]),
		fullname: new FormControl('', [
		  Validators.required,
		  Validators.pattern(/^[A-Za-z\s]+$/) // Only letters and spaces allowed
		]),
		first_name : new FormControl(''),
		second_name : new FormControl(''),
		third_name : new FormControl(''),
		Reference : new FormControl(''),
		gender : new FormControl('',[Validators.required]),
		DOB : new FormControl('',[Validators.required]),
		Age : new FormControl(''),
		nationality:new FormControl('',[Validators.required]),
		//PatientID : new FormControl(''),
		is_pregnant:new FormControl(''),
		//patient_number  : new FormControl(''),
		MaritalStatus: new FormControl(''),
		preferred_contact: new FormControl(''),
		mobile: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{10}$')]),
		email: new FormControl('',[Validators.required, Validators.email]),
		Address : new FormControl(''),
		Country : new FormControl('',[Validators.required]),
		State : new FormControl('',[Validators.required]),
		City : new FormControl('',[Validators.required]),
		PinCode: new FormControl('', [Validators.pattern('^[0-9]{6}$')]),
		center : new FormControl('',[Validators.required]),
		visit_no: new FormControl(''),
		OrgID : new FormControl(''),
		CliName : new FormControl('',[Validators.required]),
		Clicode : new FormControl(''),
		ExPatientNo : new FormControl(''),
		// PatientStatus : new FormControl('',[Validators.required]),
		source_from : new FormControl(''),
		Source : new FormControl(''),
		PassportNo : new FormControl(''),
		contact_number : new FormControl(''),
		emg_contact_name: new FormControl(''),
		emg_contact_number: new FormControl(''),
		insurance_company: new FormControl(''),
		referral_organisation: new FormControl(''),
		education_level: new FormControl(''),
		occupation: new FormControl(''),
		emg_contact_relationship: new FormControl(''),
		patient_photo_id_proof: new FormControl(''),
		insurance: new FormControl(''),
		referral_type: new FormControl(''),
		referral_person: new FormControl(''),
		about_us: new FormControl(''),
		reports: new FormControl(''),
		Status : new FormControl(1),
		cms_package: new FormControl(''),
		referral_contact: new FormControl(''),
		gender_orthers: new FormControl(''),
		education_orthers: new FormControl(''),
		occupation_orthers: new FormControl(''),
		relationship_orthers: new FormControl(''),
		referral_orthers: new FormControl(''),
		about_orthers: new FormControl(''),
		// packages: this.formBuilder.array([this.createPackage()]),
		// Payments: this.formBuilder.array([this.createPayment()]),
		// rebate_name: new FormControl(''),
		// total: new FormControl(0),
		// balance: new FormControl(''),     
		
		new_package: new FormControl(''),
		//upload: new FormControl(""),
	  })
	
	  Error = (controlName: string, errorName: string) => {
		return this.RegisterForm.controls[controlName].hasError(errorName);
	  };

	Error1 = (controlName: string, errorName: string) => {
	return this.loginForm.controls[controlName].hasError(errorName);
	};
	
	onNameInput(event: Event): void {
	const input = event.target as HTMLInputElement;
	input.value = input.value.replace(/[^a-zA-Z\s]/g, ''); // Allow spaces along with letters
	}
	  
	  disableDate() {
		return false; // Implement the logic to disable the date input
	  }
  
	  get phoneControl() {
		return this.RegisterForm.get('mobile');
	  }

// Example: 10 digits only
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    // Remove any non-numeric character
    input.value = input.value.replace(/[^0-9]/g, '');
  }

	   

	  Agestatus() {
		const dob = this.RegisterForm.get('DOB').value;
		const currentYear = new Date().getFullYear();
		const dobYear = new Date(dob).getFullYear();
		const age = currentYear - dobYear;
	  
		if (age < 21) {
		  this.RegisterForm.get('MaritalStatus').setValue(8);
		  this.RegisterForm.get('is_pregnant').setValue(3);
		  console.log(this.RegisterForm.get('MaritalStatus').value);
		  
		}
		else{
		  this.RegisterForm.get('MaritalStatus').setValue(null);
		  this.RegisterForm.get('is_pregnant').setValue(null);
		}
		
	  }
	  selectedGender: string = '';
	  onGenderChange(event:any) {
		this.selectedGender = event.value;
	  }
	  Salutation:any
	  getSalutation() {
		this.api
		.getAPI(environment.API_URL + "master/lookup?type__code=TIT&status=1&order_type=asc&order_column=sequence")
		.subscribe((res)=> {
		  this.Salutation = res.data;  
		});
	};

	Center:any
	getCenter() {
	  this.api
	  .getAPI(environment.API_URL + "master/center")
	  .subscribe((res)=> {
		this.Center = res.data;  
		
	  });
  };
	Gender:any
	getGender() {
		this.api
		.getAPI(environment.API_URL + "master/lookup?type__code=GENDER&status=1&order_type=asc&order_column=sequence")
		.subscribe((res)=> {
		  this.Gender = res.data;  
		});
	};

	MaritalStatus:any
	getMaritalStatus() {
		this.api
		.getAPI(environment.API_URL + "master/lookup?type__code=MS&status=1&order_type=asc&order_column=sequence")
		.subscribe((res)=> {
		  this.MaritalStatus = res.data;  
		});
	};

	VisitType:any
	getVisitType() {
		this.api
		.getAPI(environment.API_URL + "master/lookup?type__code=REFRAL&status=1&order_type=asc&order_column=sequence")
		.subscribe((res)=> {
		  this.VisitType = res.data;  
		});
	};

	refrel_person:any
	onReferalType(event:any){
	  this.refrel_person = event.value
	}
  
	ReferralPerson:any
	getReferralPerson() {
		this.api
		.getAPI(environment.API_URL + "master/lookup?type__code=REFPSON&status=1&order_type=asc&order_column=sequence")
		.subscribe((res)=> {
		  this.ReferralPerson = res.data;  
		});
	};

	EducationLevel:any
	getEducationLevel() {
		this.api
		.getAPI(environment.API_URL + "master/lookup?type__code=EDULEV&status=1&order_type=asc&order_column=sequence")
		.subscribe((res)=> {
		  this.EducationLevel = res.data;  
		});
	};
	selectedGender2: any;
	onGenderChange2(event:any) {
	  console.log("onGenderChange2",event.value);
	  
	  this.selectedGender2 = event.value;
  
	}

	Occupation:any
	getOccupation() {
		this.api
		.getAPI(environment.API_URL + "master/lookup?type__code=OCCUPN&status=1&order_type=asc&order_column=sequence")
		.subscribe((res)=> {
		  this.Occupation = res.data;  
		});
	};
	selectedGender1:any
	onGenderChange1(event:any) {
		console.log("onGenderChange1",event.value);
		this.selectedGender1 = event.value;
	  }


	  EmergencyRelationship:any
	  getEmergencyRelationship() {
		  this.api
		  .getAPI(environment.API_URL + "master/lookup?type__code=EMEREL&status=1&order_type=asc&order_column=sequence")
		  .subscribe((res)=> {
			this.EmergencyRelationship = res.data;  
		  });
	  };

	  selectedRelationship: any = '';
	  onRelationshipChange(event:any) {
		console.log("onRelationshipChange",event.value);
		this.selectedRelationship = event.value;
	  }
	countries:any=[]
    getCountry() {
      this.patientdet = this.api.decryptData(localStorage.getItem('applicant-details'));
      console.log("Patient Details:", this.patientdet);
    
      let country_id = this.patientdet?.country_id || '43'; 
    
      if (this.patientdet && this.patientdet.country_id) {
        this.applicant_data = this.patientdet;        
        console.log('Applicant Data:', this.applicant_data);
        console.log('Country ID from applicant:', country_id);
        this.RegisterForm.patchValue({ Country: country_id });
      } else if (this.countrynew) {
        country_id = this.countrynew; 
      }
    
      let apiUrl = environment.API_URL + "master/countries?status=1";
      apiUrl += `&id=${country_id}`; 
    
      this.api.getAPI(apiUrl).subscribe((res) => {
        this.countries = res.data;
        console.log('this.countries', this.countries);
        this.countries.length===1?this.RegisterForm.patchValue({ Country: this.countries?.[0]?.id }):null;

        this.selectableCountries = this.countries.map(country => country.code.toLowerCase());
        // console.log("this.ofc_phone",this.ofc_phone)
        // if (this.ofc_phone && this.ofc_phone.allCountries) {
        //   let allCountryRef = this.ofc_phone.allCountries.filter((country) => {
        //     return this.api.inArray(country.iso2, this.selectableCountries);
        //   });
        //   this.ofc_phone.allCountries = allCountryRef;
        // } else {
        //   console.error('ofc_phone is undefined or allCountries is not initialized.');
        // }

        // if (this.ofc_phone2 && this.ofc_phone2.allCountries) {
        //   let allCountryRef = this.ofc_phone2.allCountries.filter((country) => {
        //     return this.api.inArray(country.iso2, this.selectableCountries);
        //   });
        //   this.ofc_phone2.allCountries = allCountryRef;
        // } else {
        //   console.error('ofc_phone is undefined or allCountries is not initialized.');
        // }
    
        const selectedCountry = this.countries.find(country => country.id === country_id);
        this.selectedCurrency = selectedCountry ? selectedCountry.currency : '';
    
        this.getCity(country_id);
        this.getState(country_id);
        this.getnationality();
      });
    }

	nationality:any
	getnationality(){
		this.api.getAPI(environment.API_URL + "master/nationality?status=1").subscribe({
		  next: (res) => {
		  console.log("nationalitynationality",this.nationality)
		  this.nationality = res.data.filter((nationality: any) => 
			nationality.code === 'IND'
		  );
		  this.nationality.length===1 ?this.RegisterForm.patchValue({nationality:this.nationality?.[0]?.id}):null;
	
		  console.log("232323",this.nationality)
		
		  },
		});
	  }
	cities:any=[]
    getCity(option) {
    
      this.api
      .getAPI(environment.API_URL + "master/cities?status=1&state__country_id="+option)
      .subscribe((res)=> {
        this.cities = res.data;
        this.cities.length===1 ?this.RegisterForm.patchValue({City:this.cities?.[0]?.id}):null;
      });
    }

	state:any=[]
    getState(id) {
      this.api
      .getAPI(environment.API_URL + "master/states?country_id="+id+"&status=1")
      .subscribe((res)=> {
        this.state = res.data;
      });
    }
    ClientsList:any;
    getClient(module = '') {
      this.api
        .getAPI(environment.API_URL + "master/clients?status=1")
        .subscribe((res) => {
          this.ClientsList = res.data.map(client => ({
            ...client,
            clientlist: `${client.client_name}-${client.client_code}`
          }));
          const defaultClient = this.ClientsList.find(client => client.client_code === 'WALKIN');
		if (defaultClient) {
			this.RegisterForm.get('CliName')?.setValue(defaultClient.id);
		}
        });
    }

    setClientId(clientId: string) {
      this.RegisterForm.get('CliName').setValue(clientId);
    }
	   
	onSubmit() {
		this.RegisterForm.markAllAsTouched();
	
		// if ((!this.files || this.files.length === 0) && (!this.pdfFiles || this.pdfFiles.length === 0) && (!this.patientdetupload || this.patientdetupload.length === 0)) {
		//   this.notification.displayMessage("Please upload at least one TRF file.");
		//   return;
		// }
		
		console.log("RegisterForm", this.RegisterForm)
		
		if (this.RegisterForm.valid) {
			const formData = new FormData();
			const formValueWithCreatedBy = {
				...this.RegisterForm.value,
				created_by: this.api.userid.user_id,
			};
	
			console.log("Form Data With Created By:", formValueWithCreatedBy);
	
			if (formValueWithCreatedBy.DOB) {
				formValueWithCreatedBy.DOB = moment(formValueWithCreatedBy.DOB).format(environment.DATE_FORMAT_REVERSE);			}
	
			Object.keys(formValueWithCreatedBy).forEach(key => {
				formData.append(key, formValueWithCreatedBy[key]);
			});
	
			let is_pregnant = this.RegisterForm.value.is_pregnant;
			formData.append('is_pregnant', is_pregnant == null ? 3 : is_pregnant);
			this.api.postAPI(
				environment.API_URL + "transaction/cms/registration/update",
				formData
			).subscribe(res => {
				if (res.status === environment.SUCCESS_CODE) {
					this.notification.success(res.message);
					this.applicant_data = res.data[0];
					this.RegisterForm.reset();
					console.log("Applicant Data:", this.applicant_data);
					this.api.navigateByUrl('/index');
				} else {
					this.notification.displayMessage(res.message);
				}
			}, error => {
				console.error("API error:", error);
				this.notification.displayMessage("An error occurred during submission.");
			});
		} else {
			this.notification.displayMessage("Please fill in all required fields.");
		}
	}


	// Login Section
public loginButton='Sign in';
  public signinDisable=false;
  userDetail:any;
	public loginForm = new FormGroup({
		patient_number: new FormControl("", [Validators.required]),
		password: new FormControl("", [Validators.required]),
		remember: new FormControl("")
	  });
	
	hide:any
	togglePasswordVisibility(event: MouseEvent) {
		event.preventDefault();
		this.hide = !this.hide;
	  }


	  LoginSubmit() {
    
		if (this.loginForm.valid) {
		  this.loginButton='Please wait...';
		  this.signinDisable=true;
		//   this.api.displayLoading(true);
		  let patientNumber=this.loginForm.value.patient_number;
		  let loginPassword=this.loginForm.value.password;
		  this.loginForm.patchValue({patient_number:'',password:''});
		  this.api.getApplicantToken(
			patientNumber,
			//this.loginForm.value.password
			this.api.encrypt(loginPassword,environment.SECRET_KEY)
		  )
		  .subscribe((res) => {
	
			this.loginButton='Sign in';
			this.signinDisable=false;
			if(res.status=='success'){
			  localStorage.setItem('applicant-token-detail',this.api.encryptData(res));
			  let loginName = 'applicant';
			  let loginPassword= 'Applicant@123';
			  // console.log('res',this.api.decryptData(localStorage.getItem('token-detail')));
			  //this.api.navigateByUrl('/client/dashboard-applicant');
			  this.api.getToken(
				loginName,
				//this.loginForm.value.password
				this.api.encrypt(loginPassword,environment.SECRET_KEY)
			  )
			  .subscribe((res) => {
				this.loginButton='Sign in';
				this.signinDisable=false;
				if(res.status=='success')
					{
					  console.log(res.status,'111111111111')
					  this.logged(res)
					  this.api.setUserLoggedIn(true);
					  if(this.loginForm.value.remember) {
						localStorage.setItem('userInfo',this.api.encryptData(this.loginForm.value));
					  }
					  this.api.navigateByUrl('/index');
					  // this.api.navigateByUrl('/locations/countries');
	  
					  this.api.getAccessUser(loginName,this.api.encrypt(loginPassword,environment.SECRET_KEY)).subscribe((resAccess)=>{
						res={
						  ...res,
						  ...resAccess
						}
						localStorage.setItem('token-detail',this.api.encryptData(res));
						if(res.data_access.length==0)
						{
						  this.notification.displayMessage("It seems no previlleges has been set for this account. Please contact administrator");
						}
						else
					   { 
						if(res.data_access.length>1 || (res.data_access.length==1 && res.data_access[0].locations.length>1)) {
							// this.api.navigateByUrl('/authenticate/role-selection',{skipLocationChange: true});
							this.api.displayLoading(false);
							let defaultLocation=(res.data_access[0].locations).filter(function(loc){ if(loc.default_location==1) return loc; }).map(function(obj) {return obj;});
							if(defaultLocation.length>0)
							{
								let data =this.api.decryptData(localStorage.getItem('token-detail'));
								/*console.log("data",data);
								return false;*/
								data.permissions = (this.api.decrypt(res.data_access[0].user_role.permissions,environment.SECRET_KEY));
								
								let centre=defaultLocation.length>0?defaultLocation[0].centre:'';
	  
								data.role_code=res.data_access[0].user_role.code;
								data.center=centre?centre.id:'';
								data.center_name=centre?centre.name:'';
								data.center_country=centre?centre.country:'';
								data.center_city=centre?centre.city:'';
								data.country_name=defaultLocation.length>0?defaultLocation[0].country.name:'';
								data.city_name=defaultLocation.length>0?defaultLocation[0].city && defaultLocation[0].city.name:'';
								data.role_name = res.data_access[0].user_role.name;
								data.role_id = res.data_access[0].user_role.id;
								data.currentAccess=res.data_access[0];
	  
								let processID=res.data_access[0].user_role.processes_id;
								data.process_id=processID;
								console.log("data",data);
								this.api.postAPI(environment.API_URL+"api/auth/authentications",{user_id:this.api.encrypt(res.user_id,environment.SECRET_KEY),user_role_id:this.api.encrypt(res.data_access[0].user_role.id,environment.SECRET_KEY),center_id:this.api.encrypt((centre?centre.id:''),environment.SECRET_KEY)}).subscribe((res2)=>{
								  data.token_user=data.currentAccess.locations.length>0?data.currentAccess.locations[0].tms_userName:'';
	  
								  localStorage.setItem('token-detail',this.api.encryptData(data));
								  this.api.updateUserID();
								//   setTimeout(()=>{
								// 	// this.api.displayLoading(false);
								// 	console.log('res2res2',res2)
								// 	if(res2.authentication.biometric) {
								// 	  if(res2.authentication.fpdata.length<2) {
								// 	   this.api.navigateByUrl('/authenticate/biometrics-log');
								// 	  } else {
								// 		this.api.navigateByUrl('/authenticate/biometrics-verify');
								// 	  }
								// 	} else if(res2.authentication.twofactor){
								// 	  this.api.navigateByUrl('/authenticate/twofactor');
								// 	} else {
								// 	//   this.api.redirectToCorrespondingPage(processID);
								// 	this.api.navigateByUrl('/index');
								// 	}
								//   },300)
								  
								});
							}
							else
							{
							  this.api.navigateByUrl('/authenticate/role-selection');
							}
							
						  
						} else {
	  
							  let data =this.api.decryptData(localStorage.getItem('token-detail'));
							  /*console.log("data",data);
							  return false;*/
							  data.permissions = (this.api.decrypt(res.data_access[0].user_role.permissions,environment.SECRET_KEY));
							  
							  let centre=res.data_access[0].locations.length>0?res.data_access[0].locations[0].centre:'';
	  
							  data.role_code=res.data_access[0].user_role.code;
							  data.center=centre?centre.id:'';
							  data.center_name=centre?centre.name:'';
							  data.center_country=centre?centre.country:'';
							  data.center_city=centre?centre.city:'';
							  data.country_name=res.data_access[0].locations.length>0?res.data_access[0].locations[0].country.name:'';
							  data.city_name=res.data_access[0].locations.length>0?res.data_access[0].locations[0].city && res.data_access[0].locations[0].city.name:'';
							  data.role_name = res.data_access[0].user_role.name;
							  data.role_id = res.data_access[0].user_role.id;
							  data.currentAccess=res.data_access[0];
	  
							  let processID=res.data_access[0].user_role.processes_id;
							  data.process_id=processID;
							  
							  this.api.postAPI(environment.API_URL+"api/auth/authentications",{user_id:this.api.encrypt(res.user_id,environment.SECRET_KEY),user_role_id:this.api.encrypt(res.data_access[0].user_role.id,environment.SECRET_KEY),center_id:this.api.encrypt((centre?centre.id:''),environment.SECRET_KEY)}).subscribe((res2)=>{
								data.token_user=data.currentAccess.locations.length>0?data.currentAccess.locations[0].tms_userName:'';
	  
								localStorage.setItem('token-detail',this.api.encryptData(data));
								this.api.updateUserID();
								// setTimeout(()=>{
								//   this.api.displayLoading(false);
								//   if(res2.authentication.biometric) {
								// 	if(res2.authentication.fpdata.length<2) {
								// 	 this.api.navigateByUrl('/authenticate/biometrics-log');
								// 	} else {
								// 	  this.api.navigateByUrl('/authenticate/biometrics-verify');
								// 	}
								//   } else if(res2.authentication.twofactor){
								// 	this.api.navigateByUrl('/authenticate/twofactor');
								//   } else {
								// 	this.api.redirectToCorrespondingPage(processID);
								//   }
								// },300)
								
							  });
							  
						}  
					   }
					  });
	  
					  
				  }
			  });
	
			}else{
			  this.api.displayLoading(false);
			  this.notification.displayMessage(res.message);
			}
				 
		  });
			
		}  
		
		   
	  }
	
	logged(data=''){
		this.Header1Component.loginCheck(data)
	}


}